
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AppointmentCTA = () => {
  return (
    <section className="py-24 bg-amber-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* Left - Image */}
          <motion.div
            className="relative h-96 lg:h-auto"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="https://static.readdy.ai/image/97be066482875b82b2fddabc195c0943/bce472cc5d79efe8c56c5acc50535cc1.jpeg"
              alt="Professional consultation"
              className="w-full h-full object-cover object-top lg:rounded-r-3xl"
              loading="lazy"
            />
          </motion.div>

          {/* Right - Content */}
          <motion.div
            className="bg-white flex items-center justify-center p-12 lg:p-16"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="max-w-lg">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
                Ready to Take the Next Step?
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Schedule your comprehensive psychiatric evaluation or medication management appointment today. We accept most major insurance plans including Optum, Aetna, Cigna, Medicaid, and Medicare.
              </p>
              <Link
                to="/appointment"
                className="inline-flex items-center space-x-3 bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-full text-lg font-semibold transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap mb-6"
                aria-label="Make an appointment"
              >
                <span>Make an Appointment</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
              <p className="text-gray-500 flex items-center space-x-2">
                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>Or call us at <a href="tel:+17206552560" className="text-blue-600 hover:text-blue-700 font-semibold transition-colors" aria-label="Call us at (720) 655-2560">(720) 655-2560</a></span>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentCTA;
